import { Input, Button } from '@shared/components';
import './EarlyAccessView.css';

/**
 * View (UI) for Early Access Section
 * Pure presentational component - receives all data and handlers as props
 */
export const EarlyAccessView = ({ showForm, formData, onFieldChange, onSubmit, onShowForm, isSubmitting, message }) => {
  return (
    <section className="early-access">
      <div className="container">
        <div className="early-access__content">
          <h2 className="early-access__title">Rejoignez les premiers lecteurs de Bookiner</h2>

          <p className="early-access__description">
            Bookiner est actuellement en cours de développement. Si cette vision vous parle, suivez l'aventure et inscrivez-vous dès maintenant pour
            accéder à la version de démonstration et faire partie des premiers utilisateurs.
          </p>

          {!showForm ? (
            <div className="early-access__cta">
              <Button type="button" variant="secondary" size="lg" onClick={onShowForm}>
                Rejoindre la liste de démonstration
              </Button>
            </div>
          ) : (
            <form className="early-access__form" onSubmit={onSubmit}>
              <div className="early-access__form-fields">
                <Input
                  type="email"
                  name="email"
                  label="Email"
                  placeholder="votre@email.com"
                  value={formData.email}
                  onChange={onFieldChange('email')}
                  fullWidth
                  required
                  aria-label="Adresse email"
                />
                
                <div className="early-access__name-group">
                  <Input
                    type="text"
                    name="firstname"
                    label="Prénom"
                    placeholder="Votre prénom"
                    value={formData.firstname}
                    onChange={onFieldChange('firstname')}
                    fullWidth
                    aria-label="Prénom (optionnel)"
                  />
                  
                  <Input
                    type="text"
                    name="lastname"
                    label="Nom"
                    placeholder="Votre nom"
                    value={formData.lastname}
                    onChange={onFieldChange('lastname')}
                    fullWidth
                    aria-label="Nom (optionnel)"
                  />
                </div>

                <div className="early-access__textarea-wrapper">
                  <label htmlFor="usecase" className="early-access__textarea-label">
                    Cas d'usage <span className="early-access__required">*</span>
                  </label>
                  <textarea
                    id="usecase"
                    name="usecase"
                    className="early-access__textarea"
                    placeholder="Décrivez comment vous comptez utiliser Bookiner..."
                    value={formData.usecase}
                    onChange={onFieldChange('usecase')}
                    required
                    rows="4"
                    aria-label="Cas d'usage"
                  />
                </div>
              </div>

              <Button type="submit" variant="secondary" size="lg" fullWidth disabled={isSubmitting}>
                {isSubmitting ? 'Inscription...' : 'S\'inscrire à la démo'}
              </Button>

              <p className="early-access__reassurance">
                Aucun spam. Vous pouvez vous désinscrire à tout moment.
              </p>

              {message.text && (
                <div className={`early-access__message early-access__message--${message.type}`}>
                  {message.text}
                </div>
              )}
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default EarlyAccessView;
